export const messages = {
  en: {
    resetStaffPwd: {
      confirmOperation: 'Please confirm your operation',
      confirmResetPwd: 'Confirm to reset password?',
      cancel: 'Cancel',
      confirmReset: 'Confirm Reset',
      resetSuccess: 'Password reset successful, new password is {pwd}, please change it promptly'
    }
  },
  zh: {
    resetStaffPwd: {
      confirmOperation: '请确认您的操作',
      confirmResetPwd: '确认是否重置密码',
      cancel: '点错了',
      confirmReset: '确认重置',
      resetSuccess: '修改密码成功，密码为{pwd}，请及时修改密码'
    }
  }
}